var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c("mini-header", {
        attrs: {
          title: "SIRE",
          dense: true,
          breadcrumbs: _vm.breadcrumbs,
          hiddenTab: true,
        },
      }),
      _c(
        "v-container",
        { staticStyle: { "min-height": "75vh" } },
        [
          _c(
            "v-row",
            {
              staticClass: "fill-height",
              attrs: { align: "center", justify: "center" },
            },
            [
              !_vm.$helpers.hasSomePermission(["download_sire"])
                ? _c("PermissionDenied")
                : _c(
                    "v-col",
                    {
                      staticClass: "px-0 mx-auto",
                      staticStyle: { "min-width": "580px" },
                      attrs: { cols: "8" },
                    },
                    [
                      _c("v-empty-state", {
                        attrs: {
                          type: "sire",
                          id: "sire",
                          height: 250,
                          customClass: "mt-8",
                          hiddenDescription: true,
                          isFree: true,
                          title:
                            "Selecciona el rango de fechas que deseas descargar",
                          description: "El rango no debe ser superior a 7 días",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "actions",
                            fn: function () {
                              return [
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "mt-5",
                                    attrs: {
                                      align: "center",
                                      justify: "center",
                                      "no-gutters": "",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "mx-2 pa-0 text-left",
                                        staticStyle: { width: "175px" },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-block grey-700--text body-2",
                                          },
                                          [_vm._v("Desde")]
                                        ),
                                        _c(
                                          "v-menu",
                                          {
                                            attrs: {
                                              "close-on-content-click": false,
                                              "offset-y": "",
                                              "nudge-bottom": 10,
                                              transition: "slide-y-transition",
                                              "max-width": "280",
                                              "z-index": "1000",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "activator",
                                                fn: function ({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "v-text-field",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            attrs: {
                                                              "append-icon":
                                                                "mdi-calendar-blank",
                                                              placeholder:
                                                                "dd-mm-aaaa",
                                                              outlined: "",
                                                              "single-line": "",
                                                              dense: "",
                                                              readonly: "",
                                                              "hide-details":
                                                                "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.startDate,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.startDate =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "startDate",
                                                            },
                                                          },
                                                          "v-text-field",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      )
                                                    ),
                                                  ]
                                                },
                                              },
                                            ]),
                                            model: {
                                              value: _vm.startDateMenu,
                                              callback: function ($$v) {
                                                _vm.startDateMenu = $$v
                                              },
                                              expression: "startDateMenu",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-date-picker",
                                              {
                                                attrs: {
                                                  max: _vm.minDateStart,
                                                  "no-title": "",
                                                  "first-day-of-week": 1,
                                                  type: "date",
                                                  locale: "es",
                                                  width: "270",
                                                  color: "grey-900",
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    _vm.startDateMenu = false
                                                  },
                                                },
                                                model: {
                                                  value: _vm.startDate,
                                                  callback: function ($$v) {
                                                    _vm.startDate = $$v
                                                  },
                                                  expression: "startDate",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-row",
                                                  {
                                                    staticClass:
                                                      "pt-0 mb-1 px-5",
                                                  },
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        staticClass: "body-1",
                                                        attrs: {
                                                          ripple: false,
                                                          text: "",
                                                          color: "grey-900",
                                                        },
                                                        on: {
                                                          click: () => {
                                                            _vm.startDate = null
                                                            _vm.startDateMenu = false
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("Limpiar")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "mx-2 pa-0 text-left",
                                        staticStyle: { width: "175px" },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-block grey-700--text body-2",
                                          },
                                          [_vm._v("Hasta")]
                                        ),
                                        _c(
                                          "v-menu",
                                          {
                                            attrs: {
                                              "close-on-content-click": false,
                                              "offset-y": "",
                                              "nudge-bottom": 10,
                                              transition: "slide-y-transition",
                                              "max-width": "280",
                                              "z-index": "1000",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "activator",
                                                fn: function ({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "v-text-field",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            attrs: {
                                                              "append-icon":
                                                                "mdi-calendar-blank",
                                                              placeholder:
                                                                "dd-mm-aaaa",
                                                              outlined: "",
                                                              "single-line": "",
                                                              dense: "",
                                                              readonly: "",
                                                              "hide-details":
                                                                "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.endDate,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.endDate =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "endDate",
                                                            },
                                                          },
                                                          "v-text-field",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      )
                                                    ),
                                                  ]
                                                },
                                              },
                                            ]),
                                            model: {
                                              value: _vm.endDateMenu,
                                              callback: function ($$v) {
                                                _vm.endDateMenu = $$v
                                              },
                                              expression: "endDateMenu",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-date-picker",
                                              {
                                                attrs: {
                                                  min: _vm.startDate,
                                                  max: _vm.maxDate,
                                                  "no-title": "",
                                                  "first-day-of-week": 1,
                                                  type: "date",
                                                  locale: "es",
                                                  width: "270",
                                                  color: "grey-900",
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    _vm.endDateMenu = false
                                                  },
                                                },
                                                model: {
                                                  value: _vm.endDate,
                                                  callback: function ($$v) {
                                                    _vm.endDate = $$v
                                                  },
                                                  expression: "endDate",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-row",
                                                  { staticClass: "mb-1 px-5" },
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        staticClass: "body-1",
                                                        attrs: {
                                                          ripple: false,
                                                          text: "",
                                                          color: "grey-900",
                                                        },
                                                        on: {
                                                          click: () => {
                                                            _vm.endDate = null
                                                            _vm.endDateMenu = false
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("Limpiar")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "mx-2 pa-0 pt-4" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "grey-900",
                                              loading: _vm.loading,
                                              ripple: false,
                                              width: 153,
                                            },
                                            on: { click: _vm.createExport },
                                          },
                                          [_vm._v("Descargar")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                      _c(
                        "v-col",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "v-alert",
                            {
                              staticClass:
                                "inf-alert-blue green-500--text rounded-md mt-2 mx-auto",
                              attrs: {
                                height: 56,
                                width: 540,
                                dense: "",
                                text: "",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex align-center pa-0 my-0",
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "pt-1",
                                      attrs: { color: "grey-900", size: "22" },
                                    },
                                    [_vm._v("mdi-information-outline")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "ml-4 mt-1 d-flex align-center text-left",
                                    },
                                    [
                                      _c("span", { staticClass: "body-2" }, [
                                        _vm._v("Esta acción "),
                                        _c(
                                          "span",
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              "podría tardar varios minutos"
                                            ),
                                          ]
                                        ),
                                        _vm._v(
                                          " en completarse. No cierres el navegador hasta completar la descarga. "
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }